import React from 'react';
import InternationalTaxProfileContent from './international_tax_profile_content';
import Dac7SellerReports from './dac7_seller_reports';

interface Props {
  availableDac7ReportYears: number[];
}

export function InternationalTaxProfileContainer({ availableDac7ReportYears }: Props) {
  return (
    <>
      <Dac7SellerReports
        availableDac7ReportYears={availableDac7ReportYears}
      />
      <InternationalTaxProfileContent />
    </>
  );
}

export default InternationalTaxProfileContainer;
